import { createReducer } from '@reduxjs/toolkit';

import { fetchRefDataRequest, fetchRefDataSuccess } from './actions';

/** @type {import('./types').RefData} */
const initialState = {};

const refDataReducer = createReducer(initialState, (builder) => {
  builder.addMatcher(fetchRefDataRequest.match, () => initialState);
  builder.addMatcher(fetchRefDataSuccess.match, (_, { payload }) => payload);
});

export default refDataReducer;
